import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=bc1d156c&scoped=true&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"
import style0 from "./Layout.vue?vue&type=style&index=0&id=bc1d156c&prod&lang=scss&"
import style1 from "./Layout.vue?vue&type=style&index=1&id=bc1d156c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1d156c",
  null
  
)

export default component.exports